import React from 'react';
import { useStyles } from './version.module';

const Version = () => {
  const classes = useStyles();

  return <div className={classes.versionPage}>{'1.0.1'}</div>;
};

export default Version;
